export default __webpack_public_path__ + "static/media/Blade of Resilience.36aeccca.jpg";